export const toggleSlide = () => {
  const links = document.querySelectorAll('.wrapper_our_activities .menu .menu-item a')
  const pictures = document.querySelectorAll('.wrapper_our_activities .visuel_text_container .visuel_text')

  // console.log('test')

  if (links.length && pictures.length) {
    links.forEach((link, key) => {
      link.addEventListener('click', function () {
        event.preventDefault()

        links.forEach((link) => {
          link.classList.remove('active')
        })
        link.classList.add('active')

        pictures.forEach((picture) => {
          picture.classList.remove('show')
        })
        pictures[key].classList.add('show')
      })
    })
  }
}
